export const user = (profile?: Profile): string => {
  const index = profile?.index || 0;
  return `user-${(index % 10) + 1}`;
};
